import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContextMenuService } from 'src/app/services/context-menu/context-menu.service';

@Component({
	selector: 'cpi-context-menu',
	templateUrl: './context-menu.component.html',
	styleUrl: './context-menu.component.scss',
})
export class ContextMenuComponent implements OnInit {
	constructor(public ContextMenuService: ContextMenuService) {}

	ngOnInit(): void {}

	@Output()
	onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

	onContextMenuClick(event, data): any {
		this.onContextMenuItemClick.emit({
			event,
			data,
		});
	}
}
